// extracted by css-extract-rspack-plugin
export default {"lastSeenDesc":"FvX5DeTJifoQtCWE","lastSeenEnv":"n5wA9ERY9r0kbyG4","active":"tGQgMA4NDGQEZnaS"};